export interface HtmlModuleProps {
  html: string
}

export const HtmlModule: React.FC<HtmlModuleProps> = ({ html }) => {
  if (!html) return null
  return <div dangerouslySetInnerHTML={{ __html: html }} />
}
